/**
 * Call "scrollIntoView" and wait until it stops scrolling
 * Check container scroll value until it stops changing
 */
export function scrollToElement(args: {
  element?: HTMLElement;
  container: HTMLElement;
  options: ScrollIntoViewOptions | ScrollToOptions;
}): Promise<void> {
  const { element, container = document.body, options = {} } = args;

  return new Promise(resolve => {
    const CHECK_SCROLL_DELAY = 100;
    let lastScrollTopValue = Number.MIN_SAFE_INTEGER;

    const checkIfScrollIsComplete = (): void => {
      if (container.scrollTop !== lastScrollTopValue) {
        lastScrollTopValue = container.scrollTop;
        checkAgainLater();
      } else {
        resolve();
      }
    };

    const checkAgainLater = () => {
      setTimeout(checkIfScrollIsComplete, CHECK_SCROLL_DELAY);
    };

    if (element) {
      element.scrollIntoView(options);
    } else if (Number.isFinite((options as ScrollToOptions).top)) {
      container.scrollTo(options as ScrollToOptions);
    }

    checkAgainLater();
  });
}
